import React, { useEffect, useState,Fragment, useReducer } from 'react'
import { Badge, Button, Col, Container, Form, FormControl, InputGroup, ListGroup, Row, OverlayTrigger, Tooltip} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import buscarReducer, { initialStateDisabled } from './storeBuscar/buscar-Reducer'
import { INIT, RESET, SET_DIAS, SET_DISABLED, SET_TIPO_GESTION } from './storeBuscar/types'
import {useFormik} from 'formik'
import { restarMeses } from '../../common/Formatos'
import { Auth, LoadingComponent } from 'recupero-comunes'
import { validationSchemas } from '../../common/validation-Schemas-directo'
import { useLocation, useNavigate } from 'react-router-dom'
import { limpiarCasosBandeja, obtenerCasosBandeja, obtenerTareasAction, obtenerTareasUsuarioAction, obtenerComboRegionCorte, obtenerComboJuzgadoTribunal } from '../../store/actions/encargado-recupero-action'
import { serviceGetGenerales, servicesGetConceptos, serviceGetDespachos } from '../../api/encargado-recupero-client';

const hoy = () => {
  const fecha = new Date()
  const hoy = fecha.toISOString().split('T')[0]
  return hoy
}

const resetValues={tipofecha:'',dias:'',situacion:'',estadocaso:'',
    tipogestion:'',tarea:'', extrajudicial:false,judicial:false,todos:true, intanciajudicial:'',idcarpeta:'',idcaso:'',patente:'',siniestro:'',
    fechahasta:'',fechadesde:'', competencia: '', jurisdiccion: '', departamento: '', municipio: '', despacho:'', sinliquidado:''}

const BuscarCasos = () => {  
  const history = useNavigate()
  const [loading, setLoading]=useState(false)
  const [myValues, setMyValues]=useState(resetValues)
  const [noFechas, setNoFechas]=useState(true)

  const [selected, setSelected]=useState('')
  const [dias, setDias]=useState('')
  
  const [isDias, setIsDias]=useState(false)
  
  const [isFechas, setIsfechas]=useState(true)
  const {rutUsuario, rutOrganizacion}=Auth.currentUser()
  const data_encargado_recupero = useSelector((state) => state.encargado_recupero);
  const {cfg_form, rangofechas, tipogestion, tareas, estadocaso, intanciajudicial, criteriofecha, tareasusuario, competencias} = data_encargado_recupero
  
  const [stateBuscar, dispatchBuscar]=useReducer(buscarReducer, initialStateDisabled)
  const dispatch = useDispatch()
  const { state } = useLocation()
  let querState =state?.queryState && state?.queryState

  const [juridicciones, setJuridicciones] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [municipiosAll, setMunicipiosAll] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [despachos, setDespachos] = useState([]);
  const [stateCompetencia, setStateCompetencia] = useState("");
  const [stateJuridiccion, setStateJuridiccion] = useState("");
  const [stateDepartamento, setStateDepartamento] = useState("");
  const [stateMunicipio, setStateMunicipio] = useState("");
  const [agrupaCompetencia, setAgrupaCompetencia] = useState("");
     
  const handleRadio=(e)=>{
    setSelected(e.target.id)
    if(e.target.id==='tipogestion'){       
      dispatchBuscar({type:RESET})
      dispatchBuscar({type:SET_TIPO_GESTION, payload:{disabled:true, name:e.target.id}})
    } else {
      dispatchBuscar({type:RESET})
      dispatchBuscar({type:SET_DISABLED, payload:{disabled:true, name:e.target.id}})
    }
    setMyValues(resetValues)
    setIsfechas(false)      
    setIsDias(false)      
  }

  const handleLimpliar=()=>{
    setIsfechas(true)
    setSelected('')
    dispatchBuscar({type:INIT})
    dispatch(limpiarCasosBandeja())
    setMyValues(resetValues)
   querState=null
    
      setIsDias(false)
      if(rangofechas){
        setMyValues({...resetValues, fechahasta:hoy(), fechadesde:restarMeses(parseInt(rangofechas['valorParametro']))})
        }
  }
  useEffect(()=>{
    dispatchBuscar({type:INIT})

  },[])

  useEffect(()=>{   
    if (querState) {
      let resultado={}
      let valores = Object.values(querState); 
      let myKeys = Object.keys(querState); 
      for(let i=0; i< valores.length; i++){
        
        if (valores[i]!=='' && myKeys[i]!=='rutcia' && myKeys[i]!=='rutusr' ) {
          if (myKeys[i]==='audienciapendiente'  ) {
            setIsDias(valores[i])            
          } else {
            if (valores[i]!==false) {
              resultado[myKeys[i]]=valores[i]
            }
          }
        }
      }      
      if (resultado.competencia) {
        handleBackCompetencia(resultado);
      }
      let valoresR = Object.values(resultado); 
      let myKeysR = Object.keys(resultado); 
      let filter={...resetValues}
      for (let i=0; i< valoresR.length; i++) {
        if (Object.entries(resultado).length===1 ) {
              setNoFechas(false)
              dispatchBuscar({type:RESET})
              dispatchBuscar({type:SET_DISABLED, payload:{disabled:false, name:myKeysR[i]}})
              setMyValues({...resetValues,[myKeysR[i]]:valoresR[i], fechadesde:''})
        } else {
          if (myKeysR[i]==='tipogestion' || myKeysR[i]==='intanciajudicial' ) {
            setNoFechas(false)
            dispatchBuscar({type:INIT})            
            for(let j=0; j< Object.entries(resultado).length; j++){
              filter[myKeysR[j]]=valoresR[j]
            }
            setMyValues(filter)          
          } else {
            setNoFechas(false)
            for (let j=0; j< Object.entries(resultado).length; j++) {
              if (myKeysR[j]==='tarea' || myKeysR[j]==='estadocaso' || myKeysR[j] ==='competencia') {
                dispatchBuscar({type:RESET})
                dispatchBuscar({type:SET_DISABLED, payload:{disabled:false, name:myKeysR[j]}})
              }            
              filter[myKeysR[j]]=valoresR[j]
            }            
            setMyValues(filter)
          }
        }      
      }  
      
      querState['rutcia'] = rutOrganizacion && rutOrganizacion
      querState['rutusr'] = rutUsuario && rutUsuario
      let query1 = Buffer.from(JSON.stringify(querState)).toString('base64')
      dispatch(obtenerCasosBandeja(query1))
     
    }
    setIsfechas(false)
    querState = null
    history('/area-trabajo-recupero-directo')

  },[state])

  useEffect(()=>{
    if(rangofechas && querState!==null && noFechas){
    setMyValues({...myValues, fechahasta:hoy(), fechadesde:restarMeses(rangofechas && parseInt(rangofechas['valorParametro']))})
  }
  },[rangofechas])
  
  const onSubmitByColor = (color) => {
    setLoading(true)
    let todos = document.getElementById('todos') ? document.getElementById('todos').checked : false;
    let query = { rutcia: rutOrganizacion, rutusr: rutUsuario, todos: todos, color: color}
    
    localStorage.setItem('filtrosRecuperoDirecto',JSON.stringify(query));
    query = Buffer.from(JSON.stringify(query)).toString('base64');
    
    dispatch(obtenerCasosBandeja(query)).then(() => {
      setLoading(false)
    })
  }
  const obtenerTareasUsuario = () => {
    let query = Buffer.from(JSON.stringify({ rutcia: rutOrganizacion, rutusr: rutUsuario, flujo: 3, flujo1: 4 })).toString('base64')
    setLoading(true)
    dispatch(
      obtenerTareasUsuarioAction(query)
    ).then(() => {

      let queryTareas = Buffer.from(
        JSON.stringify({rutcia: rutOrganizacion, rutusr: rutUsuario, flujo: 3, flujo1: 4,
          todos: document.getElementById('todos')
            ? document.getElementById('todos').checked
            : false
        })
      ).toString('base64')
      dispatch(obtenerTareasAction(queryTareas)).then(() => {
          setLoading(false)
      })
    })
  }
// CARGA INICIAL DE COMBOS
const initCmbJudiciales = async () => {
  const jurid = await getJuridicciones();
  const deptos = await getDepartamentos();
  const comunas = await getComunas();
  return { jurid, deptos, comunas };
};
const getCompetencias = async () => {
  const query = Buffer.from(JSON.stringify({ concepto: 240 })).toString("base64");
  const response = await servicesGetConceptos(query);
  return response;
};
const getJuridicciones = async () => {
  const query = Buffer.from(JSON.stringify({ concepto: 296 })).toString("base64");
  const response = await servicesGetConceptos(query);
  setJuridicciones(response);
  return response;
};
const getDepartamentos = async () => {
  const query = Buffer.from(JSON.stringify({ tabla: 47 })).toString("base64");
  const response = await serviceGetGenerales(query);
  setDepartamentos(response);
  return response;
};
const getComunas = async () => {
  const query = Buffer.from(JSON.stringify({ tabla: 45 })).toString("base64");
  const response = await serviceGetGenerales(query);
  setMunicipiosAll(response);
  return response;
};

// CAMBIO DE COMPETENCIA
const handleChangeCompetencia = async (value, competenciasParam) => {

  await initCmbJudiciales();
  let competenciasList = competenciasParam ?? competencias;

  if (!competenciasList || competenciasList.length === 0) {
    const compResponse = await getCompetencias(); 
    competenciasList = compResponse;              
  }

  setStateCompetencia(value);

  if (value !== "") {
    const competencia = competenciasList.find(
      c => Number(c.id) === Number(value)
    );
    setAgrupaCompetencia(competencia?.agrupacion);
    setStateJuridiccion(competencia?.descConcepto);
    setStateMunicipio("");
    setStateDepartamento("");
  }
};

// CAMBIO DE JURISDICCIÓN
const handleChangeJuridiccion = async (value) => {
  setStateJuridiccion(value);
};

// CAMBIO DE DEPARTAMENTO
const handleChangeDepartamento = async (
  value,
  departamentosParam,
  municipiosAllParam
) => {
  setStateDepartamento(value);

  const departamentosList = departamentosParam ?? departamentos;
  const municipiosList = municipiosAllParam ?? municipiosAll;

  if (value === "") {
    await getComunas();
    return;
  }
  const atr2Depto = departamentosList.find(
    d => Number(d.codUnico) === Number(value)
  )?.codUnico;

  const comunasFiltradas = municipiosList.filter(
    c => Number(c.atr2) === Number(atr2Depto)
  );
  setMunicipios(comunasFiltradas);
};

// CAMBIO DE MUNICIPIO
const handleChangeMunicipio = async (
  value,
  competenciaParam,
  juridiccionParam,
  departamentoParam
) => {
  setStateMunicipio(value);

  if (value === "") return;

  const competencia = competenciaParam ?? stateCompetencia;
  const juridiccion = juridiccionParam ?? stateJuridiccion;
  const departamento = departamentoParam ?? stateDepartamento;

  await getDespachos(competencia, juridiccion, departamento, value);
};

// OBTENER DESPACHOS
const getDespachos = async (competencia, juridiccion, departamento, municipio) => {
  const query = Buffer.from(
    JSON.stringify({
      competencia,
      juridiccion,
      departamento,
      municipio
    })
  ).toString("base64");

  const response = await serviceGetDespachos(query);
  setDespachos(response);
};
// RESTAURAR FILTROS (AL VOLVER A LA PANTALLA)
const handleBackCompetencia = async (filtros) => {
  try {
    setLoading(true)

    // 1. Cargar combos y obtener las listas correctas
    const { jurid, deptos, comunas } = await initCmbJudiciales();

    // 2. Competencia (paso la lista correcta)
    await handleChangeCompetencia(filtros.competencia, competencias);

    // 3. Jurisdicción
    await handleChangeJuridiccion(filtros.juridiccion);

    // 4. Departamento (paso listas deptos y comunas correctas)
    await handleChangeDepartamento(
      filtros.departamento,
      deptos,
      comunas
    );

    // 5. Municipio (paso los valores reales)
    await handleChangeMunicipio(
      filtros.municipio,
      filtros.competencia,
      filtros.jurisdiccion,
      filtros.departamento
    );
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};


  const formik = useFormik({
    initialValues: {
      tipogestion: '',
      extrajudicial:false,
      judicial:false,
      todos: true,
      tarea:'',
      estadocaso:'',
      intanciajudicial:'',
      audienciapendiente: false,
      dias: '',
      fechadesde:'',
      fechahasta:'',
      tipofecha: '',
      siniestro: '',
      patente:'',
      idcaso: '',
      competencia: '',
      jurisdiccion: '',
      departamento: '',
      municipio: '',
      despacho: '',
      sinliquidado:''
            
    },
    validationSchema: validationSchemas(isFechas, isDias,selected),
    onSubmit: (formData) => {
      setLoading(true)
        const dataForm = {
            ...formData
        }
        let query ={}
        dataForm['rutcia'] = rutOrganizacion && rutOrganizacion
        dataForm['rutusr'] = rutUsuario && rutUsuario  
        for (let key in dataForm) {
          if (dataForm[key] !== null && dataForm[key] !== '') {
            query[key] = dataForm[key]
          }  
        }         
        localStorage.setItem('filtrosRecuperoDirecto',JSON.stringify(query))
        query = Buffer.from(JSON.stringify(query)).toString('base64')
        dispatch(limpiarCasosBandeja()) 
        dispatch(obtenerCasosBandeja(query)).then(() => {
        setLoading(false)      
      })                
    }
})

  return (
    <>
 <style type='text/css'>
        {`
    .btn-limpiar {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-buscar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    
    `}
    </style>
      <LoadingComponent show={loading}/>
    <Form onSubmit={
                formik.handleSubmit
            }>
          <Container>
            <Container>
            
              {cfg_form? (
                <div >
                  
                <Row>
                <Col md='4' >
                   <Form.Label className='mb-2 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }} >
                     {cfg_form['bandejatareasabo-filtro-tipogestion']}
                   </Form.Label>{' '}
                   <br />
                   <Form.Select disabled={!stateBuscar.tipogestion.disabled}
                       onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,tipogestion:e.target.value})                        
                      }}
                      value={formik.values.tipogestion=myValues.tipogestion}
                      name='tipogestion'
                      error={formik.values.error}
                   >
                   <option value={''}>Seleccione...</option>
                        {tipogestion &&
                          tipogestion?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                   </Form.Select>
                 </Col>                
                 <Col md='2'>
                 <Form.Check 
                    type='checkbox'
                    id='extrajudicial'
                    name='extrajudicial'
                    checked={Boolean(myValues.extrajudicial)}                   
                    label={cfg_form['bandejatareasabo-filtro-extrajudicial']}
                    className='mt-5'
                    onChange={e=>{                      
                      formik.handleChange(e)                      
                      setMyValues({...myValues, extrajudicial:(e.target.checked)})
                    }}
                    value={formik.values.extrajudicial=myValues.extrajudicial}
                  />                 
                </Col>
                <Col md='2'>
                  <Form.Check 
                    type='checkbox'
                    id='judicial'
                    name='judicial'
                    checked={Boolean(myValues.judicial)}                   
                    label={cfg_form['bandejatareasabo-filtro-judicial']}
                    className='mt-5'
                    onChange={e=>{
                      formik.handleChange(e)
                      setMyValues({...myValues, judicial:(e.target.checked)})                                            
                    }}
                    value={formik.values.judicial=myValues.judicial}
                  />                 
                </Col>                
                <Col md='2'>
                  <Form.Check 
                    type='checkbox'
                    id='todos'
                    name='todos'
                    checked={Boolean(myValues.todos)}                    
                    label={cfg_form['bandejatareasabo-filtro-todos']}
                    className='mt-5'
                    onChange={e=>{                        
                      formik.handleChange(e)                      
                      setMyValues({...myValues, todos:(e.target.checked)})
                    }}
                    value={formik.values.todos=myValues.todos}
                  />
                </Col>
               </Row>                       
                <Row >
                  <Col md='4'>
                   <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                     {cfg_form['bandejatareasabo-filtro-tarea']}
                     <OverlayTrigger overlay={<Tooltip id='tooltip-disabled'>Recargar Tareas Pendientes </Tooltip>}>
                        <Button type="button" style={{ float: 'right', backgroundColor: 'white', color: 'black', border: 'none', marginBottom:'-7px' }} variant="outline-secondary" size="sm" onClick={() => obtenerTareasUsuario()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                            </svg>
                        </Button>
                      </OverlayTrigger>
                   </Form.Label>{' '}
                   <br />
                   <InputGroup>
                     <InputGroup.Radio aria-label="Radio button for following text input" 
                     name='select' id='tarea' 
                     checked={stateBuscar.tarea.disabled}
                     onChange={e=>handleRadio(e)}/>
                     <Form.Select disabled={!stateBuscar.tarea.disabled}
                      onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,tarea:e.target.value})
                       
                      }}
                      value={formik.values.tarea=myValues.tarea}
                      name='tarea'
                      error={formik.values.error}
                     >
                     <option value={''}>Seleccione...</option>
                        {tareas &&
                          tareas?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                     </Form.Select>
                 </InputGroup>
                 {formik.errors.tareas ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.tareas}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                 </Col>
                 <Col md='4'>
                   <Form.Label
                     className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '14px' }}
                   >
                     {
                       cfg_form[
                         'bandejatareasabo-filtro-estadocaso'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <InputGroup>
                     <InputGroup.Radio aria-label="Radio button for following text input" 
                     name='select' id='estadocaso' 
                     checked={stateBuscar.estadocaso.disabled}
                     onChange={e=>handleRadio(e)}/>
                     <Form.Select disabled={!stateBuscar.estadocaso.disabled}
                      onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,estadocaso:e.target.value})
                       
                      }}
                      value={formik.values.estadocaso=myValues.estadocaso}
                      name='estadocaso'
                      error={formik.values.error}
                     >
                     <option value={''}>Seleccione...</option>
                        {estadocaso &&
                          estadocaso?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                     </Form.Select>
                 </InputGroup>
                 {formik.errors.estado ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.estado}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                 </Col>
                 <Col md='2'>
                  <Form.Check 
                    type='checkbox'
                    id='sinliquidado'
                    name='sinliquidado'
                    checked={Boolean(myValues.sinliquidado)}                    
                    label={cfg_form['bandejatareasabo-filtrochk-sinliquidado']}
                    className='mt-5'
                    onChange={e=>{                        
                      formik.handleChange(e)                      
                      setMyValues({...myValues, sinliquidado:(e.target.checked)})
                    }}
                    value={formik.values.sinliquidado=myValues.sinliquidado}
                  />
                </Col>
                 {/*Col md='4' >
                   <Form.Label
                     className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '14px' }}
                   >
                     {
                       cfg_form[
                         'bandejatareasabo-filtro-intanciajudicial'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Select disabled={!stateBuscar.intanciajudicial.disabled}
                       onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,intanciajudicial:e.target.value})
                        
                      }}
                      value={formik.values.intanciajudicial=myValues.intanciajudicial}
                      name='intanciajudicial'
                      error={formik.values.error}
                   >
                   <option value={''}>Seleccione...</option>
                        {intanciajudicial &&
                          intanciajudicial?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                   </Form.Select>
                  </Col>*/}                 
               </Row>               
                <Row >
                 <Col md='3'>
                   <Form.Label
                     className='mb-2 mt-4'
                     
                     style={{ fontWeight: 'bold', fontSize: '14px' }}
                   >
                     {
                       cfg_form[
                         'bandejatareasabo-filtro-fechadesde'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   
                     <Form.Control type='date'disabled={!stateBuscar.fechadesde.disabled}
                     name='fechadesde'
                     value={formik.values.fechadesde=myValues.fechadesde}
                     onChange={(e)=>{
                       formik.handleChange(e)
                       setMyValues({...myValues,fechadesde:e.target.value})
                      
                     }
                     }
                     ></Form.Control>
                
                 </Col>
                 <Col md='3' >
                   <Form.Label
                     className='mb-2 mt-4'
                    
                     style={{ fontWeight: 'bold', fontSize: '14px' }}
                   >
                     {
                       cfg_form[
                         'bandejatareasabo-filtro-fechahasta'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Control type='date'  disabled={!stateBuscar.fechahasta.disabled}
                      name='fechahasta'
                      value={formik.values.fechahasta=myValues.fechahasta}
                      onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,fechahasta:e.target.value})
                        
                      }
                      }
                   ></Form.Control>
                 </Col>
                 <Col md='3' >
                   <Form.Label
                     className='mb-2 mt-4'                     
                     style={{ fontWeight: 'bold', fontSize: '14px' }}
                    
                   >
                     {
                       cfg_form[
                         'bandejatareasabo-filtro-tipofecha'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Select  disabled={!stateBuscar.tipofecha.disabled}
                       onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,tipofecha:e.target.value})
                       
                      }}
                      value={formik.values.tipofecha=myValues.tipofecha}
                      name='tipofecha'
                      error={formik.values.error} 
                   >
                   <option value={''}>Seleccione...</option>
                        {criteriofecha &&
                         criteriofecha?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                   </Form.Select>
                   {formik.errors.tipofecha ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.tipofecha}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                 </Col>
                 <Col md='2'>
                 <Form.Check 
                 
                    type='checkbox'
                    id='audiencia'
                    name='audienciapendiente'
                    checked={isDias}
                    disabled={!stateBuscar.audienciapendiente.disabled}
                    label={
                      cfg_form[
                        'bandejatareasabo-filtro-audienciapendiente'
                      ]
                      
                    }
                    style={{marginTop:'60px'}}
                    onChange={e=>{
                      formik.handleChange(e)
                      
                      setIsDias(e.target.checked)
                     
                      dispatchBuscar({type:SET_DIAS, payload: !isDias})
                     
                       
                    }}
                    value={formik.values.audienciapendiente=isDias}
                  />
                 </Col>
                 <Col md='1'>
                 <Form.Label
                     className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '14px' }}
                   >
                     {
                       cfg_form[
                         'bandejatareasabo-filtro-dias'
                       ]
                     }
                   </Form.Label>{' '}
                 <Form.Control
                 disabled={!isDias} 
                 onChange={(e)=>{
                  formik.handleChange(e)
                  setMyValues({...myValues,dias:e.target.value})
                  
                }}
                value={formik.values.dias=myValues.dias}
                name='dias'
                error={formik.values.error} 
                   
                  />
                   {formik.errors.dias ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.dias}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                 </Col>
                </Row>
                <hr style={{ color: '#04005D', height: '1px', marginTop:'20px', marginBottom:'0px'  }}></hr>
               <Row>
               <Col md='3'> 
                   <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                     {cfg_form['bandejatareasabo-filtro-competencia']}
                   </Form.Label>{' '}
                   <br />
                  <InputGroup>
                    <InputGroup.Radio aria-label="Radio button for following text input" 
                     name='select' id='competencia' 
                     checked={stateBuscar.competencia.disabled}
                     onChange={e=>handleRadio(e)}/>
                    <Form.Select disabled={!stateBuscar.competencia.disabled}
                      onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,competencia:e.target.value})
                        handleChangeCompetencia(e.target.value);
                      }}
                      value={formik.values.competencia=myValues.competencia}
                      name='competencia'
                      error={formik.values.error}
                     >
                     <option value={''}>Seleccione...</option>
                        {competencias &&
                          competencias?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                    </Form.Select>
                  </InputGroup>
                  {formik.errors.competencia ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.competencia}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                </Col>
                 <Col md='3' >
                   <Form.Label
                     className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '14px' }}
                   >
                     {
                       cfg_form[
                         'bandejatareasabo-filtro-jurisdiccion'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Select disabled={!stateBuscar.competencia.disabled}
                       onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,jurisdiccion:e.target.value})
                        handleChangeJuridiccion(e.target.value);                                            
                      }}
                      value={formik.values.jurisdiccion=myValues.jurisdiccion}
                      name='jurisdiccion'
                      error={formik.values.error}
                   >
                   <option value={''}>Seleccione...</option>
                        {juridicciones &&
                          juridicciones?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                   </Form.Select>
                 </Col>
                 <Col md='3' >
                   <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                     {cfg_form['bandejatareasabo-filtro-depto']}
                   </Form.Label>{' '}
                   <br />
                   <Form.Select disabled={!stateBuscar.competencia.disabled}
                       onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,departamento:e.target.value})
                        handleChangeDepartamento(e.target.value)
                        
                      }}
                      value={formik.values.departamento=myValues.departamento}
                      name='departamento'
                      error={formik.values.error}
                   >
                   <option value={''}>Seleccione...</option>
                        {departamentos &&
                          departamentos?.map((c) => (
                            <option key={c.codUnico} value={c.codUnico}>
                              {c.nombre}
                            </option>
                          ))}
                   </Form.Select>
                 </Col>
                 <Col md='3' >
                   <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                     {cfg_form['bandejatareasabo-filtro-municipio']}
                   </Form.Label>{' '}
                   <br />
                   <Form.Select disabled={!stateBuscar.competencia.disabled}
                       onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,municipio:e.target.value})
                        handleChangeMunicipio(e.target.value);
                        
                      }}
                      value={formik.values.municipio=myValues.municipio}
                      name='municipio'
                      error={formik.values.error}
                   >
                   <option value={''}>Seleccione...</option>
                        {municipios &&
                          municipios?.map((c) => (
                            <option key={c.codUnico} value={c.codUnico}>
                              {c.nombre}
                            </option>
                          ))}
                   </Form.Select>
                 </Col>
                 { agrupaCompetencia == 1 &&
                  <Col md='9' className='mt-2'>
                      <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                          {cfg_form['bandejatareasabo-filtro-despacho']}
                      </Form.Label>
                      <br />
                      <Form.Select
                          name='despacho'
                          value={formik.values.despacho = myValues.despacho}
                          onChange={(e) => { 
                            formik.handleChange(e);
                            setMyValues({...myValues,despacho:e.target.value})
                          }}>

                          <option value={''}>Seleccione...</option>
                          {despachos.map((c) => (
                              <option key={c.id} value={c.id}>{c.nombre}</option>
                          ))}
                      </Form.Select>
                      {formik.errors.despacho && formik.touched.despacho &&
                          <Form.Text variant='danger' style={{ color: 'red' }}>
                              {formik.errors.despacho}
                          </Form.Text>
                      }
                  </Col>
                  }
               </Row>
               <hr style={{ color: '#04005D', height: '1px', marginTop:'30px', marginBottom:'0px' }}></hr>
               <Row >
                 
                    <Col>
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form[
                            'bandejatareasabo-filtro-siniestro'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <InputGroup>
                        <InputGroup.Radio aria-label="Radio button for following text input" name='select' id='siniestro' onChange={e=>handleRadio(e)} checked={stateBuscar.siniestro.disabled}/>
                        <FormControl aria-label="Text input with radio button" disabled={!stateBuscar.siniestro.disabled}
                          onChange={(e)=>{
                            formik.handleChange(e)                          
                           
                            setMyValues({...myValues,siniestro:e.target.value})
                          }}
                          value={formik.values.siniestro=myValues.siniestro}
                          name='siniestro'
                          error={formik.values.error}
                        />
                    </InputGroup>
                    {formik.errors.siniestro ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.siniestro}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                    </Col>
                    <Col >
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form[
                            'bandejatareasabo-filtro-patente'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <InputGroup>
                        <InputGroup.Radio aria-label="Radio button for following text input" name='select'
                             id='patente' checked={stateBuscar.patente.disabled}
                             onChange={e=>handleRadio(e)} />
                        <FormControl aria-label="Text input with radio button"  disabled={!stateBuscar.patente.disabled}
                            onChange={(e)=>{
                              formik.handleChange(e)
                              setMyValues({...myValues,patente:e.target.value})
                              
                            }}
                            value={formik.values.patente=myValues.patente}
                            name='patente'
                            error={formik.values.error}
                        />
                        
                          
                    </InputGroup>
                    {formik.errors.patente ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.patente}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                    </Col>
                    <Col >
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form[
                            'bandejatareasabo-filtro-idcaso'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <InputGroup>
                        <InputGroup.Radio aria-label="Radio button for following text input"
                         name='select' id='idcaso' 
                         checked={stateBuscar.idcaso.disabled}
                         onChange={e=>handleRadio(e)}/>
                        <FormControl aria-label="Text input with radio button" disabled={!stateBuscar.idcaso.disabled}
                          onChange={(e)=>{
                            formik.handleChange(e)
                            
                            setMyValues({...myValues, idcaso: e.target.value})
                          }}
                          value={formik.values.idcaso=myValues.idcaso}
                          name='idcaso'
                          error={formik.values.error}
                      
                        />
                    </InputGroup>
                    {formik.errors.idcaso ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.idcaso}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                    </Col>                                    
                  </Row>
                  
                         
               <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
               {tareasusuario && tareasusuario[0] && tareasusuario[0].visualizaSemaforo === 1 ? (
                  <Row className='mt-4'>
                    <Col md='6'>
                      <ListGroup variant='flush'>
                        <ListGroup.Item
                          action
                          className='text-center'
                          onClick={() => {
                            obtenerTareasUsuario()
                          }}
                          type='button'
                        >
                          <Row>
                            <Col>
                              <span className='fw-bolder me-2'>
                                {cfg_form['bandejatareasabo-semaforo-titulo']}
                              </span>
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='16'
                                height='16'
                                fill='currentColor'
                                className='bi bi-arrow-clockwise'
                                viewBox='0 0 16 16'
                              >
                                <path
                                  fillRule='evenodd'
                                  d='M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z'
                                />
                                <path d='M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z' />
                              </svg>
                            </Col>
                          </Row>
                        </ListGroup.Item>
                      </ListGroup>
                    </Col>
                    <Col md='4'>
                      <ListGroup variant='flush'>
                        <ListGroup.Item className='text-center'>
                          <Row>
                            <Col className='fw-bolder'>Casos Abiertos</Col>
                          </Row>
                        </ListGroup.Item>
                      </ListGroup>
                    </Col>
                    <Col md='2'></Col>
                  </Row>
                ) : (
                  <Row className='mt-4'>
                    <Col md='4'>
                      <ListGroup variant='flush'>
                        <ListGroup.Item className='text-center'>
                          <Row>
                            <Col className='fw-bolder'>Casos Abiertos</Col>
                          </Row>
                        </ListGroup.Item>
                      </ListGroup>
                    </Col>
                    <Col md='6'></Col>
                    <Col md='2'></Col>
                  </Row>
                )}

                {tareasusuario && tareasusuario[0] && tareasusuario[0].visualizaSemaforo === 1 ? (
                  <Row>
                    <Col md='6'>
                      <ListGroup horizontal>
                        <ListGroup.Item
                          action
                          variant='danger'
                          className='text-center'
                          onClick={() => onSubmitByColor('rojo')}
                          type='button'
                        >
                          <Row>
                            <Col md='8'>{tareasusuario[0].nivel1}</Col>
                            <Col md='4'>
                              <Badge bg='danger'>{tareasusuario[0].rojo}</Badge>
                            </Col>
                          </Row>
                        </ListGroup.Item>
                        <ListGroup.Item
                          action
                          variant='warning'
                          className='text-center'
                          onClick={() => onSubmitByColor('amarillo')}
                          type='button'
                        >
                          <Row>
                            <Col md='8'>{tareasusuario[0].nivel2}</Col>
                            <Col md='4'>
                              <Badge bg='warning'>
                                {tareasusuario[0].amarillo}
                              </Badge>
                            </Col>
                          </Row>
                        </ListGroup.Item>
                        <ListGroup.Item
                          action
                          variant='success'
                          className='text-center'
                          onClick={() => onSubmitByColor('verde')}
                          type='button'
                        >
                          <Row>
                            <Col md='9'>{tareasusuario[0].nivel3}</Col>
                            <Col md='3'>
                              <Badge bg='success'>
                                {tareasusuario[0].verde}
                              </Badge>
                            </Col>
                          </Row>
                        </ListGroup.Item>
                        <ListGroup.Item className='w-100 text-center'>
                          <Row>
                            <Col md='8'>Total</Col>
                            <Col md='4'>
                              <Badge>{tareasusuario[0].total}</Badge>
                            </Col>
                          </Row>
                        </ListGroup.Item>
                      </ListGroup>
                    </Col>
                    <Col md='4'>
                      <ListGroup horizontal>
                        <ListGroup.Item className='w-100 text-center'>
                          <Row>
                            <Col md='8'>ExtraJudicial</Col>
                            <Col md='4'>
                              <Badge bg='light' text='dark'>
                                {tareasusuario[0].casosExtraJudi}
                              </Badge>
                            </Col>
                          </Row>
                        </ListGroup.Item>
                        <ListGroup.Item className='w-100 text-center'>
                          <Row>
                            <Col md='8'>Judicial</Col>
                            <Col md='4'>
                              <Badge bg='light' text='dark'>
                                {tareasusuario[0].casosJudi}
                              </Badge>
                            </Col>
                          </Row>
                        </ListGroup.Item>
                      </ListGroup>
                    </Col>
                  
               
                        
                        <Col className='d-flex align-items-end justify-content-end m-2'>
                        <Button className='m-2' variant='limpiar' onClick={handleLimpliar}  >
                        {cfg_form && cfg_form["bandejatareasabo-boton-limpiar"]}
                        </Button>
                        <Button className='m-2' variant='buscar' type='onSubmit' >
                        {cfg_form && cfg_form["bandejatareasabo-boton-buscar"]}
                        </Button>
                        
                        
                        
                        </Col>
                    </Row>):(
                      <Row>
                      <Col md='4'>
                        <ListGroup horizontal>
                          <ListGroup.Item className='w-100 text-center'>
                            <Row>
                              <Col md='8'>ExtraJudicial</Col>
                              <Col md='4'>
                                <Badge bg='light' text='dark'>
                                  {tareasusuario && tareasusuario[0] &&
                                    tareasusuario[0].casosExtraJudi}
                                </Badge>
                              </Col>
                            </Row>
                          </ListGroup.Item>
                          <ListGroup.Item className='w-100 text-center'>
                            <Row>
                              <Col md='8'>Judicial</Col>
                              <Col md='4'>
                                <Badge bg='light' text='dark'>
                                  {tareasusuario && tareasusuario[0] && tareasusuario[0].casosJudi}
                                </Badge>
                              </Col>
                            </Row>
                          </ListGroup.Item>
                        </ListGroup>
                      </Col>
                      <Col className='d-flex align-items-end justify-content-end m-2'>
                        <Button className='mx-2' variant='limpiar' onClick={handleLimpliar}  >
                        {cfg_form && cfg_form["bandejatareasabo-boton-limpiar"]}
                        </Button>
                        <Button className='mx-2' variant='buscar' type='onSubmit' >
                        {cfg_form && cfg_form["bandejatareasabo-boton-buscar"]}
                        </Button>
                        
                        
                        
                        </Col>
                        </Row>
                    )}
                    
                </div>
              ) : null}
            </Container>
           
     
      
   
          </Container>
       
     </Form>
    
    </>
  )
}

export default BuscarCasos
